module.exports = __webpack_public_path__ + "static/SpecifyPERSONAL-ExpBlack-4c4c05a1b061353b7c890fcbd15f2dc5.ttf";